module.exports = "/images/smiley.png?cea767a2591ba42196fc9d4506f2e412";